import React, { useEffect, useState } from 'react';
import { Button, Modal, Alert, Row, Col, Image, Typography, Space } from 'antd';
import SampleDataService from "services/sample_data"
import _ from "lodash"
const { Paragraph, Text } = Typography;
const service = new SampleDataService();
const ProductSample = ({ value, onChange }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [selected, setSelected] = useState([])

    useEffect(() => {
        loadData();
    }, [])

    useEffect(() => {
        if (_.isArray(value)) {
            setSelected(value);
        } else {
            setSelected([])
        }
    }, [value])

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const loadData = async () => {
        var data = await service.getProducts();
        setProducts(data);
    }
    const productClick = id => {

        var isSelect = selected.includes(id);
        var newSelect = [...selected];

        if (isSelect) {
            newSelect = newSelect.filter(x => x != id);
        } else {
            newSelect.push(id);
        }
        setSelected(newSelect);
        onChange(newSelect)
    }

    const handleSelectAll = () => {
        onChange(products.map(x => x.id));
        handleOk();
    }

    return (
        <>
            <Space direction='vertical'>

                <Alert message="Chọn sản phẩm mẫu để xem trước cách hiển thị trên website của bạn. Hệ thống sẽ tự động tạo sẵn giá, ảnh, mô tả... Bạn có thể chỉnh sửa lại sau." type="info" closable />
                <Button type="link" onClick={showModal} >
                    {selected.length == 0 ? "Chọn sản phẩm mẫu" : `Đã chọn ${selected.length} sản phẩm mẫu`}
                </Button>
            </Space>
            <Modal
                title="Chọn sản phẩm"
                closable={true}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                maskClosable={false}
                footer={
                    <Space>
                        <Button onClick={handleCancel}>Đóng</Button>
                        <Button type='primary' onClick={handleSelectAll}>Chọn tất cả</Button>
               
                    </Space>
                }
            >

                <Alert message="Chọn sản phẩm mẫu để xem trước cách hiển thị trên website của bạn. Hệ thống sẽ tự động tạo sẵn giá, ảnh, mô tả... Bạn có thể chỉnh sửa lại sau." type="info" />

                <div style={{ height: 16 }}></div>
                <Row gutter={[16, 16]}>
                    {products.map(x => {
                        var isSelect = selected.includes(x.id);
                        return (
                            <Col span={8}>

                                <div onClick={e => productClick(x.id)} style={{ width: "100%", padding: 5, borderWidth: 1, borderStyle: "solid", borderColor: isSelect ? "#1677ff" : "white" }}>
                                    <img style={{ width: "100%", aspectRatio: 1, objectFit: "contain" }} src={x.images[0].url} preview={false} ></img>
                                    <Paragraph ellipsis={true}>
                                        {x.name}
                                    </Paragraph>



                                </div>
                            </Col>
                        )
                    })}
                </Row>
            </Modal>
        </>
    );
};
export default ProductSample;